/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import {
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";

const RHFRadioGroup = ({ formData, control }) => {
  // Extract and map DataValues into options
  const options = formData?.DataValues?.split('|').map((item) => {
    const [value, label] = item.split(':');
    return { value, label };
  });

  // Generate validation rules dynamically
  const rules = formData?.Validations?.reduce((acc, validation) => {
    if (validation.ValidationType === "Required") {
      acc.required = validation.ValidationMessage || "This field is required";
    }
    return acc;
  }, {});

  return (
    <FormControl component="fieldset" error={!!rules?.required} fullWidth>
      <FormLabel  sx={{ fontSize: "14px", mb: 1 }}>
        <>
          <span style={{ color: "black", }}>{formData?.LabelName || formData?.DisplayExpr}</span>
          {rules?.required && (
            <span style={{ color: "red", marginLeft: "2px" }}>*</span>
          )}
        </>
      </FormLabel>

      <Controller
        name={formData?.ValueExpr}
        control={control}
        defaultValue={formData?.DefaultValues?.[0] ?? ""}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <>
            <RadioGroup {...field} row>
              {options?.map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                      control={<Radio  style={{ transform: 'scale(0.6)' }} />}
                  label={<span style={{ fontSize: "13px" }}>{option.label}</span>}
                />
              ))}
            </RadioGroup>
            {error && (
              <FormHelperText sx={{ fontSize: "10px" }}>
                {error.message}
              </FormHelperText>
            )}
          </>
        )}
      />
    </FormControl>
  );
};

export default RHFRadioGroup;
